import React, { useState, useRef, useEffect } from "react";

function PlantSelect({ plantOptions, value, onChange }) {
    const [query, setQuery] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Case-insensitive "anywhere" match
    const filtered = plantOptions.filter(opt =>
        opt.label.toLowerCase().includes(query.toLowerCase())
    );

    const handleSelect = (opt) => {
        onChange(opt.key);
        setQuery(opt.label); // show selected label in input
        setShowDropdown(false);
    };

    return (
        <div ref={wrapperRef} style={{ position: "relative" }}>
            <input
                type="text"
                className="form-control"
                style={{
                    border: "1px solid #222",   // darker, stronger border
                    boxShadow: "none",
                    width: "100%",
                }}
                value={query}
                onChange={(e) => {
                    setQuery(e.target.value);
                    setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
            />

            {showDropdown && (
                <ul
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        background: "#fff",
                        border: "1px solid #aaa",
                        borderTop: "none",
                        margin: 0,
                        padding: 0,
                        listStyle: "none",
                        maxHeight: "200px",
                        overflowY: "auto",
                    }}
                >
                    {filtered.length === 0 && (
                        <li style={{ padding: "8px", color: "#666" }}>No matches</li>
                    )}
                    {filtered.map((opt) => (
                        <li
                            key={opt.key}
                            style={{
                                padding: "8px",
                                cursor: "pointer",
                            }}
                            onClick={() => handleSelect(opt)}
                            onMouseDown={(e) => e.preventDefault()} // prevent blur
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#e6f0ff")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default PlantSelect;
